import {
    getData,
} from './Services'

export const getSucursalesInfo = async () => {
    const res = await getData('/sucursales');
    console.log("sucursales", res);
    return res
}

